import countries from '../data/countries.json'

export default function useCountries() {

    const top = ['US', 'UK', 'DE', 'CA', 'AU'];

    countries.sort((a, b) => {
        const aIndex = top.indexOf(a.abbreviation);
        const bIndex = top.indexOf(b.abbreviation);

        if (aIndex === -1 && bIndex === -1) {
            return 0;
        } else if (aIndex === -1) {
            return 1;
        } else if (bIndex === -1) {
            return -1;
        } else {
            return aIndex - bIndex;
        }
    });

    const formattedCountries = countries.map(({country, abbreviation}) => ({
        label: country,
        value: abbreviation
    }));

    return formattedCountries;
}
